function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.81 10a.74.74 0 00.55-.23l4.38-4.29A.89.89 0 006 4.84a.84.84 0 00-.28-.63l-4.38-4A.77.77 0 00.2.3a.88.88 0 00.08 1.2L4 4.88.26 8.52a.88.88 0 000 1.21.78.78 0 00.55.27"
});

var SvgArrowForward = function SvgArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10"
  }, props), _ref);
};

export default SvgArrowForward;